export const MAX_FILE_SIZE = 3150586;
export const NUM_OF_SELLER_QUESTIONNAIRES = 3;
export const NUM_OF_PROPERTY_QUESTIONNARIES = 7;
